import React from 'react';
import { Text, TouchableOpacity, Animated } from 'react-native';

const SkipButton = ({
  styles,
  onSkipBtnClick,
  isSkipBtnShow,
  leftTextColor,
  skipBtnLabel,
  skipFadeOpacity,
}: any) => {
  return (
    <Animated.View
      style={[
        styles.btnContainer,
        {
          opacity: skipFadeOpacity,
          transform: [
            {
              translateX: skipFadeOpacity.interpolate({
                inputRange: [0, 1],
                outputRange: [0, 15],
              }),
            },
          ],
        },
      ]}
    >
      <TouchableOpacity
        style={styles.full}
        onPress={isSkipBtnShow ? () => onSkipBtnClick() : undefined}
      >
        <Text testID="intro.skipIntro" style={[styles.controllText, { color: leftTextColor }]}>
          {skipBtnLabel}
        </Text>
      </TouchableOpacity>
    </Animated.View>
  );
};

export default SkipButton;
